/**
 * crypto.randomUUID is not supported outside secure contexts (https)
 * Use a fallback to generate a UUID
 */
export const getUUID = (): string => {
  if (typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  else {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => {
      const randomValue = crypto.getRandomValues(new Uint8Array(1))[0];
      const cValue = parseInt(c, 10);
      const adjustedValue = Math.floor(15 / Math.pow(2, Math.floor(cValue / 4)));
      const result = (cValue + (randomValue % (adjustedValue + 1))) % 16;

      return result.toString(16);
    });
  }
};

export function generateId(prefix) {
  return `${prefix}-${getUUID()}`;
}
